import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "zidongbuhuosheding"
};
const _hoisted_2 = {
  class: "panel"
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "panel-title"
}, [/*#__PURE__*/_createElementVNode("h2", null, "自动补货变更记录")], -1);

const _hoisted_4 = {
  class: "panel-body"
};
const _hoisted_5 = {
  style: {
    "text-align": "left"
  }
};

const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 分类： ");

const _hoisted_7 = {
  style: {
    "margin": "10px 0",
    "text-align": "left"
  }
};

const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 彩票： ");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("快速设置");

const _hoisted_10 = /*#__PURE__*/_createTextVNode("确定");

const _hoisted_11 = /*#__PURE__*/_createTextVNode("全部开启");

const _hoisted_12 = /*#__PURE__*/_createTextVNode("全部关闭");

const _hoisted_13 = {
  style: {
    "margin": "10px 0"
  }
};

const _hoisted_14 = /*#__PURE__*/_createTextVNode("重 置");

const _hoisted_15 = /*#__PURE__*/_createTextVNode("确定修改");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_radio_button = _resolveComponent("el-radio-button");

  const _component_el_radio_group = _resolveComponent("el-radio-group");

  const _component_el_table_column = _resolveComponent("el-table-column");

  const _component_el_input = _resolveComponent("el-input");

  const _component_el_switch = _resolveComponent("el-switch");

  const _component_el_table = _resolveComponent("el-table");

  const _component_el_col = _resolveComponent("el-col");

  const _component_el_button = _resolveComponent("el-button");

  const _component_el_button_group = _resolveComponent("el-button-group");

  const _component_el_row = _resolveComponent("el-row");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createVNode(_component_el_radio_group, {
    modelValue: $data.pid,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.pid = $event),
    size: "small",
    onChange: $options.change_group
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.play_arr, item => {
      return _openBlock(), _createBlock(_component_el_radio_button, {
        key: item.name,
        label: item.pid
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
        _: 2
      }, 1032, ["label"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onChange"])]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createVNode(_component_el_radio_group, {
    modelValue: $data.gid,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.gid = $event),
    size: "small",
    onChange: $options.change_game
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.game_list, item => {
      return _openBlock(), _createBlock(_component_el_radio_button, {
        key: item.id,
        label: item.id
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.gname), 1)]),
        _: 2
      }, 1032, ["label"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onChange"])]), _createVNode(_component_el_table, {
    data: $data.list,
    border: "",
    size: "small",
    "highlight-current-row": "",
    "header-cell-class-name": "table-header-cell",
    "header-row-class-name": "table-header-row"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      prop: "name",
      label: "补货类型",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "straightlet_low",
      label: "最低可调额度",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "straightlet_high",
      label: "起补额度",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "let_type",
      label: "计算方式",
      align: "center"
    }, {
      default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row.let_type == 1 ? '下注额' : '下注额单组计'), 1)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "control_let",
      label: "控制额度",
      align: "center"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_input, {
        size: "small",
        modelValue: scope.row.control_let,
        "onUpdate:modelValue": $event => scope.row.control_let = $event,
        disabled: !Boolean(scope.row.display * 1)
      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "display",
      label: "是否启用",
      align: "center"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_switch, {
        size: "small",
        modelValue: scope.row.display,
        "onUpdate:modelValue": $event => scope.row.display = $event,
        "active-color": "#13ce66",
        "inactive-color": "#ff4949",
        "active-value": "1",
        "inactive-value": "0",
        "active-text": "是",
        "inactive-text": "否"
      }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["data"]), $data.list.length > 0 ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 4,
      offset: 12,
      style: {
        "line-height": "45px",
        "color": "#409eff"
      }
    }, {
      default: _withCtx(() => [_hoisted_9]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 4,
      style: {
        "padding": "6px 10px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        size: "small",
        type: "number",
        modelValue: $data.fastset.control_let,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.fastset.control_let = $event)
      }, {
        append: _withCtx(() => [_createVNode(_component_el_button, {
          size: "small",
          style: {
            "background-color": "#67c23a",
            "color": "#fff"
          },
          onClick: $options.change_fast_control_let
        }, {
          default: _withCtx(() => [_hoisted_10]),
          _: 1
        }, 8, ["onClick"])]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 4,
      style: {
        "padding": "6px 10px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_button_group, null, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          size: "small",
          type: "success",
          onClick: _cache[3] || (_cache[3] = $event => $options.change_fast_display('1'))
        }, {
          default: _withCtx(() => [_hoisted_11]),
          _: 1
        }), _createVNode(_component_el_button, {
          size: "small",
          type: "danger",
          onClick: _cache[4] || (_cache[4] = $event => $options.change_fast_display('0'))
        }, {
          default: _withCtx(() => [_hoisted_12]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_13, [_createVNode(_component_el_button, {
    size: "small",
    plain: "",
    type: "info",
    onClick: $options.get_auto_set_menu
  }, {
    default: _withCtx(() => [_hoisted_14]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    size: "small",
    type: "primary",
    onClick: $options.sub
  }, {
    default: _withCtx(() => [_hoisted_15]),
    _: 1
  }, 8, ["onClick"])])])])]);
}